import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const ConditionsComponent = () => {
    return (
        <Container maxWidth="md" sx={{ backgroundColor: '#141414', color: '#fff', padding: '2rem', borderRadius: '10px', marginTop: '2rem' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center' }}>
                Conditions Générales d'Utilisation (CGU)
            </Typography>

            <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>1. Objet</Typography>
                <Typography paragraph>
                    Les présentes conditions générales d'utilisation (ci-après dénommées "CGU") régissent l'utilisation de l'application K-Drama Tracker.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>2. Services Offerts</Typography>
                <Typography paragraph>
                    L'Application permet aux utilisateurs de créer un compte gratuitement, de rechercher des kdramas, des acteurs & actrices, d'ajouter dans différentes liste des kdramas et de les gérer.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>3. Inscription et Accès aux Services</Typography>
                <Typography paragraph>
                    Pour accéder à certaines fonctionnalités, vous devez vous inscrire. Vous êtes responsable de la confidentialité de vos identifiants d'accès.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>4. Conditions d'Utilisation des Services</Typography>
                <Typography paragraph>
                    Vous vous engagez à ne pas violer les lois en vigueur et à respecter les règles de bonne conduite.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>5. Propriété Intellectuelle</Typography>
                <Typography paragraph>
                    Tous les éléments de l'Application sont protégés par des droits de propriété intellectuelle. Toute reproduction sans autorisation est interdite.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>6. Protection des Données Personnelles (RGPD)</Typography>
                <Typography paragraph>
                    Vos données personnelles sont collectées et traitées conformément au RGPD. Vous disposez de droits d'accès, de rectification, d'opposition, et de suppression.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>7. Limitation de Responsabilité</Typography>
                <Typography paragraph>
                    L'Entreprise ne peut être tenue responsable des interruptions ou dysfonctionnements de l'Application.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>8. Modifications des CGU</Typography>
                <Typography paragraph>
                    L'Entreprise se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs en seront informés.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>9. Résolution des Litiges</Typography>
                <Typography paragraph>
                    En cas de litige, les parties s'engagent à rechercher une solution amiable. Si aucun accord n'est trouvé, les litiges seront portés devant les tribunaux français.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>10. Contact</Typography>
                <Typography paragraph>
                    Pour toute question, veuillez nous contacter à codeandhdw@gmail.com.
                </Typography>

                <Typography variant="body2" sx={{ marginTop: '2rem', fontStyle: 'italic', color: '#888' }}>
                    © 2024 K-Drama Tracker. Tous droits réservés.
                </Typography>
            </Box>
        </Container>
    );
}

export default ConditionsComponent;
